export const SET_CONSELHOS = "CONSELHOS/SET_CONSELHOS";
export const SET_CONSELHO = "CONSELHOS/SET_CONSELHO";
export const SET_PAGINATION = "CONSELHOS/SET_PAGINATION";
export const SET_LAYOUT = "CONSELHOS/SET_LAYOUT";
